export class ReloadHelper {
  public static forceReload(): void {
    // Some browsers (ie. Firefox) also allow passing a bool as an argument to reload without caches
    (<(forceGet: boolean) => void>window.location.reload)(true);
  }
}
